import { MosError } from 'src/utils/errors/MosError';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { SessionTerminationResponse } from 'src/types/session';

const deleteSessionById = async (
  sessionId: string,
): Promise<SessionTerminationResponse> => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SessionTerminationResponse>(
    `/shared/admin/sessions/${sessionId}`,
    {
      method: 'DELETE',
    },
  );

  if (response.success) {
    return response.data as SessionTerminationResponse;
  }

  throw new MosError({
    error: 'Failed to terminate session',
    statusCode: response.status,
  });
};

export default deleteSessionById;
